export const getLoadOptionsParameters = (options: any) => {
    let params: string[] = [];
    [
        'skip',
        'take',
        'requireTotalCount',
        'requireGroupCount',
        'sort',
        'filter',
        'totalSummary',
        'group',
        'groupSummary',
    ].forEach((i) => {
        if (i in options && options[i] !== undefined && options[i] !== null && options[i] !== '') {
            let val = JSON.stringify(options[i]).replaceAll('+', '%2b');
            if (i === 'filter') {
                if (options[i].filterValue) {
                    if (options[i].length == 3 && options[i][2] === options[i].filterValue) {
                        let clonedOptions = [...options[i]];
                        clonedOptions[2] = encodeURIComponent(escapeSpecialChars(clonedOptions[2]));
                        val = JSON.stringify(clonedOptions);
                    }
                } else {
                    let filter = [...options[i]];
                    let result = [];
                    for (let index = 0; index < filter.length; index++) {
                        const element = filter[index];
                        if (Array.isArray(element)) {
                            if (element.length == 3) {
                                let clonedOptions = [...element];
                                clonedOptions[2] = encodeURIComponent(escapeSpecialChars(clonedOptions[2]));
                                result.push(clonedOptions);
                            }
                        } else {
                            result.push(element);
                        }
                    }
                    val = JSON.stringify(result);
                }
            }

            params.push(`${i}=${val}`);
        }
    });
    return params;
};

//Экранирует символы { } / " \, добавляя перед ними обратный слэш.
function escapeSpecialChars(input: string) {
    if (input == null) return '';

    // Сначала экранируем обратный слэш
    let escaped = input.replace(/\\/g, '\\\\');
    // Сначала экранируем "
    escaped = escaped.replace(/"/g, '\\"');
    // Затем экранируем остальные спецсимволы
    escaped = escaped.replace(/[{}\/]/g, (match) => `\\\\${match}`);
    return escaped;
}

export const getLoadOptionsQuery = (options: any, ampersandPrefix: boolean = false) => {
    let params: string[] = getLoadOptionsParameters(options);

    let query = '';

    if (params.length > 0) query = (ampersandPrefix ? '&' : '') + params.join('&');

    return query;
};
